import { render } from "./Content.vue?vue&type=template&id=3392fcd1"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=3392fcd1&lang=css"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/configuration/Content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3392fcd1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3392fcd1', __exports__)) {
    console.log('reload')
    api.reload('3392fcd1', __exports__)
  }
  
  module.hot.accept("./Content.vue?vue&type=template&id=3392fcd1", () => {
    console.log('re-render')
    api.rerender('3392fcd1', render)
  })

}


export default __exports__